import React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import FormHelperText from '@mui/material/FormHelperText';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function MultipleSelectCheckmarks({ items, selectedItems, onChange, label }) {
  const [selected, setSelected] = React.useState(selectedItems || []);
  const [error, setError] = React.useState(false);
  const [selectAll, setSelectAll] = React.useState(false);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    setSelected(value);
    if (onChange) {
      onChange(value);
    }
    setError(value.length === 0); // Set error if no value is selected
    setSelectAll(value.length === items.length); // Update selectAll state based on selected items
  };

  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    const allItems = items.map((item) => item);
    setSelected(selectAll ? [] : allItems);
    if (onChange) {
      onChange(selectAll ? [] : allItems);
    }
    setError(selectAll); // Set error if toggling select all (deselect all)
  };

  return (
    <div>
      <FormControl sx={{ m: 1, width: 260 }} error={error}>
        <InputLabel id="demo-multiple-checkbox-label" sx={{ color: error ? 'error.main' : 'inherit' }}>{label}</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={selected}
          onChange={handleChange}
          input={<OutlinedInput label={label} />}
          renderValue={(selected) => selected.join(', ')}
          MenuProps={MenuProps}
          error={error}
        >
          <MenuItem key="select-all" value="select-all">
            <Checkbox checked={selectAll} onChange={handleSelectAll} />
            <ListItemText primary="Select All" />
          </MenuItem>
          {items?.map((item) => (
            <MenuItem key={item} value={item}>
              <Checkbox checked={selected.indexOf(item) > -1} />
              <ListItemText primary={item} />
            </MenuItem>
          ))}
        </Select>
        {error && <FormHelperText>Please select at least one value</FormHelperText>}
      </FormControl>
    </div>
  );
}
